import { Link } from "react-router-dom";
import { Instagram, Music2, ShoppingBag, MessageCircle, MapPin, Clock } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

export const Footer = () => {
  const { settings, waLink } = useSettings();
  return (
    <footer data-testid="main-footer" className="bg-brand-ink text-brand-cream">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-4">
        <div>
          <p className="font-cinzel text-xl font-bold tracking-[0.18em]">
            SALON <span className="text-brand-gold">STRAWBERRY</span>
          </p>
          <p className="mt-2 text-[10px] uppercase tracking-[0.35em] text-brand-cream/50">Your Beauty, Our Passion</p>
          <p className="mt-5 text-sm leading-relaxed text-brand-cream/60">
            More than a salon — it's your beauty destination. Hair, beauty, wellness & academy dalam satu atap mewah.
          </p>
        </div>
        <div>
          <p className="overline-label mb-5">Navigasi</p>
          <div className="flex flex-col gap-3 text-sm text-brand-cream/70">
            <Link data-testid="footer-link-layanan" to="/layanan" className="hover:text-brand-gold transition-colors">Layanan Kami</Link>
            <Link data-testid="footer-link-coloring" to="/coloring" className="hover:text-brand-gold transition-colors">Coloring Gallery</Link>
            <Link data-testid="footer-link-academy" to="/academy" className="hover:text-brand-gold transition-colors">Salon Academy</Link>
            <Link data-testid="footer-link-kontak" to="/kontak" className="hover:text-brand-gold transition-colors">Kontak & Booking</Link>
          </div>
        </div>
        <div>
          <p className="overline-label mb-5">Kunjungi Kami</p>
          <div className="flex flex-col gap-4 text-sm text-brand-cream/70">
            <span className="flex gap-3"><MapPin size={16} className="text-brand-gold shrink-0 mt-0.5" />{settings?.address || "Jl. Mekar Puspita No.100, Mekarwangi, Kec. Bojongloa Kidul, Kota Bandung"}</span>
            <span className="flex gap-3"><Clock size={16} className="text-brand-gold shrink-0 mt-0.5" />{settings?.hours || "Senin - Sabtu: 08.00 - 19.00 WIB • Minggu: 10.00 - 19.00 WIB"}</span>
          </div>
        </div>
        <div>
          <p className="overline-label mb-5">Terhubung</p>
          <div className="flex gap-3">
            {[
              { icon: Instagram, href: settings?.instagram_url, id: "instagram" },
              { icon: Music2, href: settings?.tiktok_url, id: "tiktok" },
              { icon: ShoppingBag, href: settings?.shopee_url, id: "shopee" },
              { icon: MessageCircle, href: waLink("Halo Salon Strawberry Official!"), id: "whatsapp" },
            ].map(({ icon: Icon, href, id }) => (
              <a
                key={id}
                data-testid={`footer-social-${id}`}
                href={href || "#"}
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-brand-gold/30 text-brand-gold transition-all duration-300 hover:bg-brand-gold hover:text-brand-ink"
              >
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>
      </div>
      <div className="border-t border-brand-cream/10 py-6 text-center text-xs tracking-[0.2em] uppercase text-brand-cream/40">
        © 2026 Salon Strawberry Official — All Rights Reserved
      </div>
    </footer>
  );
};
